export function installErrorHandler(appsignal, application) {
    var prevHandler = application.handleError;
    application.handleError = function (error, message, detail) {
        var span = appsignal.createSpan(function (span) {
            return span
                .setAction((detail === null || detail === void 0 ? void 0 : detail.identifier) || "[unknown Stimulus controller]")
                .setTags({ framework: "Stimulus", message: message })
                .setError(error);
        });
        appsignal.send(span);
        if (prevHandler && typeof prevHandler === "function") {
            prevHandler.apply(this, arguments);
        }
    };
}
//# sourceMappingURL=index.js.map